import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CarsCustomerService } from '@customers/services/cars.customer.service';
import { RequestsCustomerService } from '@customers/services/requests.customer.service';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import * as globals from '../globals';
import { UsersService } from '../users/users.service';

declare let imprint: any;

// Make sure this one works, will give you access to the development server
@Injectable()
export class AuthService {
  imprintValue: any;
  browserTests: any = [
    'audio',
    'availableScreenResolution',
    'canvas',
    'colorDepth',
    'cookies',
    'cpuClass',
    'deviceDpi',
    'doNotTrack',
    'indexedDb',
    'language',
    'localStorage',
    'pixelRatio',
    'platform',
    'plugins',
    'processorCores',
    'screenResolution',
    'sessionStorage',
    'timezoneOffset',
    'touchSupport',
    'userAgent',
    'webGl'
  ];
  currentUser: any;
  result;
  car: any;
  previousUrl;
  public authToken;
  private isAuthenticated = true; // Set this value dynamically
  responseData: any;
  newToken: any;
  public getToken(): string {
    return localStorage.getItem('accessToken');
  }
  public isAthenticated(): boolean {
    const token = this.getToken();
    return !this.jwtHelper.isTokenExpired();
  }

  public getDecodedToken() {
    const token = this.getToken();
    const helper = new JwtHelperService();
    if (token) {
      return helper.decodeToken(token);
    } else {
      return false;
    }
  }
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private users: UsersService,
    private carsCS: CarsCustomerService,
    private requestCS: RequestsCustomerService,
    public jwtHelper: JwtHelperService,
    private toastr: ToastrService,
    private gtn: globals.GetTokenNow,
    private cookieService: CookieService
  ) {
    try {
      if (!imprint) {
      }
    } catch (err) {
      this.imprintValue = Date.now();
      localStorage.setItem('imprintValue', this.imprintValue);
      return;
    }
    const subscription = from(imprint.test(this.browserTests));
    subscription.subscribe(
      fingerprint => {
        this.imprintValue = fingerprint;
        localStorage.setItem('imprintValue', this.imprintValue);
      },
      error => {
        console.log(error);
      }
    );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    // Always return a concrete boolean | UrlTree. Returning `undefined` (the
    // previous behaviour when the token was present but had no customer role)
    // makes Angular cancel the navigation and render nothing -> blank page.
    try {
      const token = this.getToken();
      if (!token) {
        return this.router.createUrlTree(['/login']);
      }
      if (this.jwtHelper.isTokenExpired(token)) {
        // Kick off a silent refresh, but don't leave the user on a cancelled
        // navigation -> send them to login.
        this.gtn.checkToken();
        return this.router.createUrlTree(['/login']);
      }
      const customer = this.jwtHelper.decodeToken(token);
      if (customer?.roles && customer.roles.indexOf('customer') !== -1) {
        return true;
      }
      // Decodable token but not a customer (or malformed claims): drop it and
      // send the user to login instead of hanging on a blank page.
      localStorage.removeItem('accessToken');
      return this.router.createUrlTree(['/login']);
    } catch (e) {
      localStorage.removeItem('accessToken');
      return this.router.createUrlTree(['/login']);
    }
  }

  logout() {
    const body = {
      refreshToken: localStorage.getItem('refreshToken'),
      deviceId: localStorage.getItem('imprintValue')
    };
    this.serverSideLogout();
    // Clear the session and redirect to the marketing site regardless of whether
    // the logout API call succeeds. Previously this only ran inside the success
    // callback, so a failed/slow request left the token behind and the next
    // visit landed on a blank page.
    const finish = () => {
      localStorage.clear();
      this.cookieService.delete('accessToken');
      this.cookieService.delete('refreshToken');
      window.location.href = 'https://speero.net';
    };
    this.users.logOut(body).subscribe({
      next: () => {
        this.toastr.success('تم تسجيل الخروج');
        finish();
      },
      error: () => finish()
    });
  }

  serverSideLogout() {
    return this.httpClient.get(`${globals.appURL}/customer-logout/`, this.gtn.getHeaders()).subscribe();
  }

  isLoggedIn() {
    const token = this.getToken();
    if (!token || this.jwtHelper.isTokenExpired()) {
      this.gtn.checkToken();
      return false;
    }
    return true;
  }

  getOtp(body) {
    return this.httpClient.post(`${globals.domain}/customer/login/getCode`, body).pipe(map(res => res as any));
  }
  sendCode(body) {
    return this.httpClient.post(`${globals.domain}/customer/login/sendCode`, body).pipe(map(res => res as any));
  }
}